import BaseProduct from './BaseProduct';
import { ProductId } from '../types';
import store, { getLayerOpacity } from '../state';
import { getTileUrl } from '../config';
import ManifestTimelineHelper from '../services/ManifestTimelineHelper';

export class AqiLayer extends BaseProduct {
  public readonly id: ProductId = 'aqi';

  protected onActivate(): void {
    this.refresh();
  }

  protected onDeactivate(): void {
    this.layerManager.removeBufferedRasterLayer(this.id);
  }

  protected onTimeUpdate(_date: string, _hour: string): void {
    this.refresh();
  }

  public refresh() {
    if (!this.active) return;
    const state = store.getState();
    const manifest = state.manifest;
    if (!manifest) return;

    const model = state.selectedModels['aqi'] || 'gefs';
    const aqiMode = (model === 'raqdps') ? state.aqiMode : 'aqi'; // Only RAQDPS supports AQHI
    const opacity = getLayerOpacity(this.id, 1.0);
    const current = state.currentTimeStep;
    if (!current) return;

    const clampedFrame = ManifestTimelineHelper.getClampedFrame(manifest, 'aqi', model, current);
    if (!clampedFrame) {
      this.layerManager.removeBufferedRasterLayer(this.id);
      return;
    }

    const dateStr = clampedFrame.dateStr;
    const hourStr = clampedFrame.hourStr.replace(/^Z/, '');

    // format: aqiMode_model_date_Zhour
    const formattedHour = `${aqiMode}_${model}_${dateStr}_Z${hourStr}`;
    const tiles = [
      getTileUrl(manifest, this.id, model, dateStr, formattedHour)
    ];
    this.layerManager.updateBufferedRasterLayer(this.id, tiles, opacity, undefined, 0, 5);
  }
}
export default AqiLayer;
